<mat-card class="mat-elevation-z8 container-card">
    <!-- Search bar: filtro su "Suggestion" -->
    <app-search-bar [filterFields]="['email']" [filterMap]="{ email: ['email'] }" [filterLabels]="{ email: ['Indirizzo email'] }" (filtersChanged)="onFilterChanged($event)">
    </app-search-bar>

    <!-- Tabella condivisa -->
    <app-shared-table [dataSource]="usersDataSource" [displayedColumns]="displayedColumns" [columnLabels]="columnLabels" [nameTable]="'users'" [length]="totalItems" [pageSize]="limit" [pageIndex]="pageIndex" (pageChanged)="onPageChanged($event)" (sortChanged)="onSortChanged($event)" (openModal)="openDialog($event)" [isLoading]="isLoading" [hasError]="hasError">
    </app-shared-table>

    <app-loading [showLoading]="isLoadingFullScreen"></app-loading>
</mat-card>
